import { arraysEqual } from "@escapio/shared/util/array";

/**
 * Component to save and load ids of favorite hotels to the local storage of the browser
 *
 * @author che
 */

/**
 * @type {String}
 */
const LOCAL_STORAGE_KEY = "favoriteHotels";

const onChangeListeners = [];

/**
 * @private
 * @param {Array} favorites
 */
const storeFavorites = favorites => {
	try {
		localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(favorites));
	} catch (e) {
		console.error(e);
	}
};

let favorites = [];
try {
	favorites = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
} catch (e) {
	console.error(e);
}

if (!Array.isArray(favorites)) {
	favorites = [];
}

if (favorites.some(isNaN)) {
	favorites = [];
}

window.addEventListener("storage", ({ key, newValue }) => {
	if (key !== LOCAL_STORAGE_KEY) {
		return;
	}
	const newFavorites = JSON.parse(newValue);
	if (arraysEqual(favorites, newFavorites)) {
		return;
	}
	favorites = newFavorites;
	onChangeListeners.forEach(fn => fn(favorites));
});

/**
 * @param {Number} hotelId
 */
export function addHotel(hotelId) {
	if (favorites.includes(hotelId)) {
		return;
	}

	// Add new item to top of list
	favorites.unshift(hotelId);
	storeFavorites(favorites);
	onChangeListeners.forEach(listener => listener(favorites));
}

/**
 * @param {Array} hotelIds
 */
export function removeHotels(hotelIds) {
	favorites = favorites.filter(id => !hotelIds.includes(id));
	storeFavorites(favorites);
	onChangeListeners.forEach(listener => listener(favorites));
}

/**
 * @param {Number} hotelId
 * @returns {boolean}
 */
export function contains(hotelId) {
	return favorites.includes(hotelId);
}

/**
 * @returns {Number}
 */
export function count() {
	return favorites.length;
}

/**
 * Returns List of hotel ids sorted by time they were added to the favorites
 * @returns {Array}
 */
export function getFavorites() {
	return favorites;
}

export function onChangeHotels(callback) {
	onChangeListeners.push(callback);
}
